<template>
  <div class="progress-status-tag-comp" :class="[progress, type]">
    <div class="flag" v-if="isPoint"></div>
    {{ progressLabel }}
  </div>
</template>
<script lang="ts">
import { BaseComponent, Component, Prop } from 'kuaidong-component'
import { DateWrapper, DateUtil } from 'kuaidong-lib'
@Component({
  components: {},
})
export default class ProgressStatusTag extends BaseComponent {
  @Prop({ type: String, required: false })
  status!: 'un-start ' | 'progress' | 'end'

  @Prop({ type: String, required: false })
  startTime?: string

  @Prop({ type: String, required: false })
  endTime?: string

  @Prop({ type: String, required: true, default: 'point' })
  type!: 'point' | 'tag'

  get isTag() {
    return this.type === 'tag'
  }

  get isPoint() {
    return this.type === 'point'
  }

  get startBegin() {
    return this.startTime ? DateUtil.beginningOfDay(new DateWrapper(this.startTime).date) : ''
  }

  get endBegin() {
    return this.endTime ? DateUtil.beginningOfDay(new DateWrapper(this.endTime).date) : ''
  }

  get progress() {
    if (this.status) {
      return this.status
    }

    const now = DateUtil.beginningOfDay(new DateWrapper(new Date()).date)
    if (now < this.startBegin) {
      return 'un-start'
    } else if (now > this.endBegin) {
      return 'end'
    } else {
      return 'progress'
    }
  }

  get progressLabel() {
    switch (this.progress) {
      case 'un-start':
        return '未开始'
      case 'progress':
        return '进行中'
      default:
        return '已结束'
    }
  }
}
</script>
<style lang="less">
.progress-status-tag-comp {
  display: flex;
  align-items: center;
  &.point {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    &.un-start {
      color: #fe9647;
      > .flag {
        background: #fe9647;
      }
    }
    &.progress {
      color: #3bb528;
      > .flag {
        background: #3bb528;
      }
    }
    &.end {
      color: #b8b8b8;
      > .flag {
        background: #b8b8b8;
      }
    }
  }

  &.tag {
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    border-radius: 4px;
    padding: 2px 4px;
    &.un-start {
      color: #ff8629;
      background: #ffefe3;
    }
    &.progress {
      color: #4dd238;
      background: #e4fae1;
    }
    &.end {
      color: #81848f;
      background: #f7f8fa;
    }
  }

  > .flag {
    width: 6px;
    height: 6px;
    margin-right: 4px;
    border-radius: 50%;
  }
}
</style>
